import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Circle from '@/components/UI/svg/SaveElectric/Circle';
import AirConditioner from '@/components/UI/svg/SaveElectric/AirConditioner';
import Refrigerator from '@/components/UI/svg/SaveElectric/Refrigerator';
import Monitor from '@/components/UI/svg/SaveElectric/Monitor';
import Light from '@/components/UI/svg/SaveElectric/Light';
import Washing from '@/components/UI/svg/SaveElectric/Washing';
import Plus from '@/components/UI/svg/SaveElectric/Plus';
import Minus from '@/components/UI/svg/SaveElectric/Minus';

export default function D() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('save_electric');
    const [activeTab, setActiveTab] = useState(0);

    const senceList = [
        {
            icon: <AirConditioner />,
            name: t('sec_5_tab1_sence1_title'),
            desc: t('sec_5_tab1_sence1_desc'),
        },
        {
            icon: <Refrigerator />,
            name: t('sec_5_tab1_sence2_title'),
            desc: t('sec_5_tab1_sence2_desc'),
            link: 'https://blog.ecoflow.com/jp/refrigerator-electric-bills/',
        },
        {
            icon: <Monitor />,
            name: t('sec_5_tab1_sence3_title'),
            desc: t('sec_5_tab1_sence3_desc'),
        },
        {
            icon: <Light />,
            name: t('sec_5_tab1_sence4_title'),
            desc: t('sec_5_tab1_sence4_desc'),
        },
        {
            icon: <Washing />,
            name: t('sec_5_tab1_sence5_title'),
            desc: t('sec_5_tab1_sence5_desc'),
        },
    ];

    const sence2List = [
        {
            icon: <Light />,
            name: t('sec_5_tab2_sence1_title'),
            desc: t('sec_5_tab2_sence1_desc'),
        },
        {
            icon: <AirConditioner />,
            name: t('sec_5_tab2_sence2_title'),
            desc: t('sec_5_tab2_sence2_desc'),
        },
        {
            icon: <Washing />,
            name: t('sec_5_tab2_sence3_title'),
            desc: t('sec_5_tab2_sence3_desc'),
        },
        {
            icon: <Monitor />,
            name: t('sec_5_tab2_sence4_title'),
            desc: t('sec_5_tab2_sence4_desc'),
        },
    ];

    const gotoPage = (link: any, button_name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_news',
            title_name: t('sec_5_title'),
            button_name,
        });
        window.open(link);
    };

    return (
        <div className={`save-electric-d ${css.SaveElectricD}`}>
            <div className="text-wrapper">
                <h3 className="sub-title">{t('sec_5_subtitle')}</h3>
                <p className="title">{t('sec_5_title')}</p>
            </div>
            <div
                className={`tab ${activeTab === 1 ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab(activeTab === 1 ? 0 : 1);
                    const dom = document.querySelector('.save-electric-d')?.offsetTop || 3638;
                    window.scrollTo({
                        top: dom + 142,
                        behavior: 'smooth',
                    });
                }}
            >
                <div className="icon">
                    {activeTab === 1 ? <Minus width="0.27rem" height="0.27rem" /> : <Plus width="0.27rem" height="0.27rem" stroke="#000" />}
                </div>
                <p className="tab-text">{t('sec_5_tab1')}</p>
                <section className="section-a tab-content">
                    <p className="text">{t('sec_5_tab1_text')}</p>
                    <div className="solution">
                        <Circle width="0.6rem" height="0.4rem" />
                        <p className="title">{t('sec_5_tab1_title1')}</p>
                        <p className="desc">{t('sec_5_tab1_desc1')}</p>
                    </div>
                    <div className="solution">
                        <Circle num={2} width="0.6rem" height="0.4rem" />
                        <p className="title">{t('sec_5_tab1_title2')}</p>
                        <p className="desc">{t('sec_5_tab1_desc2')}</p>
                    </div>
                    <div className="section-a-swiper">
                        <Swiper className="sence-wrapper" initialSlide={0} lazy={true} spaceBetween={20} width={310}>
                            {senceList.map((item, index) => (
                                <SwiperSlide key={index} className="sence">
                                    {item.icon}
                                    <p className={`name ${item.link ? 'link' : ''}`} onClick={() => item.link && gotoPage(item.link, item.name)}>
                                        {item.name}
                                    </p>
                                    <p className="desc">{item.desc}</p>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </section>
            </div>

            <div
                className={`tab ${activeTab === 2 ? 'active' : ''}`}
                onClick={() => {
                    setActiveTab(activeTab === 2 ? 0 : 2);
                    const dom = document.querySelector('.save-electric-d')?.offsetTop || 3638;
                    window.scrollTo({
                        top: dom + 214,
                        behavior: 'smooth',
                    });
                }}
            >
                <div className="icon">
                    {activeTab === 2 ? <Minus width="0.27rem" height="0.27rem" /> : <Plus width="0.27rem" height="0.27rem" stroke="#000" />}
                </div>
                <p className="tab-text">{t('sec_5_tab2')}</p>
                <section className="section-b tab-content">
                    <p className="text">{t('sec_5_tab2_text')}</p>
                    <div className="sence-wrapper">
                        {sence2List.map((item, index) => (
                            <div className="sence solution" key={index}>
                                <div className="top">
                                    {item.icon}
                                    <p className="title-b">{item.name}</p>
                                </div>
                                <p className="desc">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
}
